import { DistributionType } from '@vestwell-sub-accounting/models/common/DistributionType';

export const displayDividendTypeMap = {
  [DistributionType.DIV]: 'Dividend',
  [DistributionType.LTCG]: 'LTCG',
  [DistributionType.OTHER]: 'Other',
  [DistributionType.STCG]: 'STCG'
};
